// extracted by mini-css-extract-plugin
export default {"inline-edit-input":"editable_inline-edit-input__6KaHF","inline-edit-multiinput":"editable_inline-edit-multiinput__DyAbL"};